import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import AttendanceTracker from './components/AttendanceTracker';
import Analytics from './components/Analytics';
import Navigation from './components/Navigation';
import AboutPage from './components/AboutPage';
import { AttendanceProvider } from './context/AttendanceContext';
import './App.css';

function App() {
  return (
    <AttendanceProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
          <Navigation />
          <Routes>
            <Route path="/" element={<AttendanceTracker />} />
            <Route path="/tracker" element={<AttendanceTracker />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </div>
      </Router>
    </AttendanceProvider>
  );
}

export default App;